class Countdown {
  /**
   * @param {HTMLElement} element - countdown
   */
  constructor(element) {
    this.element = element;
    this.daysElement = this.element.querySelector(".js-Countdown-days");
    this.hoursElement = this.element.querySelector(".js-Countdown-hours");
    this.minutesElement = this.element.querySelector(".js-Countdown-minutes");
    this.secondsElement = this.element.querySelector(".js-Countdown-seconds");

    this.countdown();
  }

  /**
   * Calculates and displays the distance between the end date and the current date
   */
  countdown() {
    const endDate = new Date(this.element.dataset.counterEndTimestamp * 1000);
    const currentDate = new Date();
    const x = setInterval(() => {
      const distance = endDate - currentDate;

      let temp = Math.round(distance / 1000);
      const secondsOutput = temp % 60;
      temp = Math.floor(temp / 60);
      const minutesOutput = temp % 60;
      temp = Math.floor(temp / 60);
      const hoursOutput = temp % 24;
      temp = Math.floor(temp / 24);
      const daysOutput = temp;

      this.daysElement.innerHTML = daysOutput;
      this.hoursElement.innerHTML = hoursOutput;
      this.minutesElement.innerHTML = minutesOutput;
      this.secondsElement.innerHTML = secondsOutput;

      if (distance < 0) {
        clearInterval(x);
        this.daysElement.innerHTML = 0;
        this.hoursElement.innerHTML = 0;
        this.minutesElement.innerHTML = 0;
        this.secondsElement.innerHTML = 0;
      }

      currentDate.setTime(currentDate.getTime() + 1000);
    }, 1000);
  }
}

export default Countdown;
